import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/warehouse";

class StockReport {
  @observable isLoading = false;
  @observable tableData = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 10 };

  @observable tableDetailData = [];
  @observable PageDetailInfo = { pageIndex: 1, pageSize: 10 };
  @observable PageMaterInfo = { pageIndex: 1, pageSize: 10 };  //原材料库存报表的数据
  @observable PageInventoryInfo = { pageIndex: 1, pageSize: 10 };  //库存明细数据列表
  @observable searchMaterialId = "";
  @observable searchSupplierId = "";
  @observable searchLocationNo = "";
  @observable searchClientId = "";
  @observable searchOrigin = "";
  @observable searchStartDate = "";
  @observable searchEndDate = "";
  @observable searchMaterialType = "";
  @observable searchOrderNo = "";
  @observable searchPlanNo = "";

  @observable type = 0; //设置对应页面展示的结果

  @observable materialType = ""; //库存物料类型
  @observable detailClientId = "";
  @observable detailSupplierId = "";
  @observable detailUnitAmount = "";
  @observable detailMaterialId = "";
  @observable  supplierId = "";   //存储供应商id
  @observable  materialId= "";   //存储物料id
  @observable materialName='' //存储物料的名称
  @observable detailOrigin = "";
  @observable detailPlanId = "";
  @observable  startDate= ""; //原材料库存报表的时间查询
  @observable  endDate = ""; //原材料库存报表的时间查询
  @observable  detailedSupplierId = ""; //原材料库存报表库存明细供应商Id的存储
  @observable  detailedMaterialId = ""; //原材料库存报表库存明细物料名称Id的存储
  @observable MaterReportTable = []; //原材料库存报表
  @observable supplierData = []; //原材料库存报表
  @observable masterData = []; //原材料库存报表
  @observable MaterReportDetail = []; //原材料库存报表
  @observable BalanceQuantity=0
  //获取表格数据
  @action.bound async getData(type, params) {
    this.isLoading = true;
    //1库存报表1  2:库存报表2
    const url =
      type === 1
        ? services.requestUrl.stockReportList
        : services.requestUrl.stockReportList2;

    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.PageInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }

//原材料库存报表列表接口
@action.bound async getMaterReportList(params){
  this.isLoading=true;
  const url=services.requestUrl.MaterReportList;
  try{
     let res=await services.getRequest(url,{
       ...params,
       ...this.PageMaterInfo
     });
     this.isLoading=false;
     if(isDataExist(res)){
       res.data.data.items.map(item=>{
         item.name=item.material&&item.material.name||''
         item.fullName=item.supplier&&item.supplier.fullName||''
         return item
       })
    this.MaterReportTable=res.data.data.items;
    this.PageMaterInfo.total=res.data.data.page.total
    this.PageMaterInfo.pageIndex=res.data.data.page.pageIndex
    this.PageMaterInfo.pageSize=res.data.data.page.pageSize
     }
  }catch(error){
    console.log(error)
  }
}

@action.bound async getMaterReportDetail(params){
  this.isLoading=true;
  const url=services.requestUrl.MaterReportDetail;
  try{
      let res=await services.getRequest(url,{
       ...params,
       ...this.PageInventoryInfo,
      });
      this.isLoading=false;
      if(isDataExist(res)){
        // console.log('res11111,',res)
        this.MaterReportDetail=res.data.data.items
        this.PageInventoryInfo.total=res.data.data.page.total
        this.PageInventoryInfo.pageIndex=res.data.data.page.pageIndex
        this.PageInventoryInfo.pageSize=res.data.data.page.pageSize
      }
  }catch(error){
    console.log(error)
  }
}
  //获取表格明细详情数据
  @action.bound async getDetailData(type, params) {
    this.isLoading = true;
    //1原材料入库列表  2:成品入库   3:库存报表2明细
    const url =
      type === 1
        ? services.requestUrl.getRawMaterialStockDetailList
        : type === 2
          ? services.requestUrl.finishedProductStockList
          : services.requestUrl.stockReportDetail2;
    try {
      let res = await services.getRequest(url, {
        ...params,
        ...this.PageDetailInfo,
      });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableDetailData = res.data.data.items;
        this.PageDetailInfo = res.data.data.page;
        // console.log(this.tableDetailData);
      }
    } catch (error) {
      console.log(error);
    }
  }
 //获取供应商下拉接口
 @action.bound async getSupplier(params){
  this.isLoading=true;
  const url=services.requestUrl.getSupplier
   try{
   let res=await services.getRequest(url,{
     ...params,
   })
   this.isLoading=false;
   if(isDataExist(res)){
   this.supplierData=res.data.data
   }
   }catch(error){
     console.log(error)
   }
 }
//物料名称下拉接口
@action.bound async getMaster(params){
this.isLoading=true;
const url=services.requestUrl.getMaster;
  try{
    let res=await services.getRequest(url,{
      ...params,
    })
    this.isLoading=false;
    if(isDataExist(res)){
 this.masterData=res.data.data.items
    }
  }catch(error){
    console.log(error)
  }
}
  // 清除数据
  @action clearData() {
    this.tableData = [];
    this.PageInfo = { pageIndex: 1, pageSize: 10 };
    this.tableDetailData = [];
    this.PageDetailInfo = { pageIndex: 1, pageSize: 10 };
    this.PageMaterInfo={pageIndex:1,pageSize:10};
    this.PageInventoryInfo={pageIndex:1,pageSize:10};
    this.searchMaterialId = "";
    this.searchSupplierId = "";
    this.searchLocationNo = "";
    this.searchClientId = "";
    this.searchOrigin = "";
    this.searchStartDate = "";
    this.searchEndDate = "";
    this.searchMaterialType = "";
    this.searchOrderNo = "";
    this.searchPlanNo = "";

    this.type = 0;

    this.materialType = ""; //库存物料类型
    this.detailClientId = "";
    this.detailSupplierId = "";
    this.detailUnitAmount = "";
    this.detailMaterialId = "";
    this.detailOrigin = "";
    this.detailPlanId = "";
    this.startDate="";
    this.endDate="";
    this.supplierData=[];
    this.masterData=[];
    this.materialId="";
    this.materialName='';
    this.supplierId = ""; 
    this.detailedSupplierId=''
    this.detailedMaterialId=''
    this.BalanceQuantity=0
  }
}

let StockReportStore = new StockReport();
export default StockReportStore;
